<template>
<div class="bottom-footer flexr justify_center">
  <p>Copyright © 安陆市涢创投资开发有限公司 Rights Reserved<br>
    鄂ICP备2025107417号-1</p>
</div>
</template>

<script>
export default {
  name: "bottomFooter"
}
</script>

<style scoped lang="scss">
.bottom-footer{
  height: 102px;
  background: #012955;
  border-radius: 0px 0px 0px 0px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 1px;
}
</style>
